if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      // live theme code

      //  onSubmitHandler(evt) {
      //   evt.preventDefault();
      //   if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      //   this.handleErrorMessage();
      //   const dropdownSelected = document.querySelector('.dropdown-selected');

      //   let mainProductImage = '';
      //   let mainProductName = '';
      //   let mainProductMinQty = '';
      //   if (dropdownSelected) {
      //     mainProductImage = dropdownSelected.getAttribute('data-main-product-image') || '';
      //     mainProductName = dropdownSelected.getAttribute('data-main-product-name') || '';
      //     mainProductMinQty = dropdownSelected.getAttribute('data-main-product-qty') || '';
      //   }
      //   const productTag = this.closest('.product')?.dataset.productTag;
      //   const formTags = this.form?.dataset.productTags?.split(',') || [];
      //   // Get diffuser product ID (outside tab)
      //   const diffuserInput = document.querySelector('.diffuser-product');
      //   const diffuserProductId = diffuserInput && diffuserInput.value ? diffuserInput.value : null;
      //   // Declare fragranceSelections outside the conditional scope
      //   let fragranceSelections = [];
      //   // Find the main quantity input from the closest .product container (shared for both)
      //   const qtyInput = this.closest('.product')?.querySelector('.quantity__input');
      //   const sharedQuantity = qtyInput && qtyInput.value ? parseInt(qtyInput.value, 10) : 1;
      //   // Get all selected fragrance variants from active tab
      //   if (formTags.includes(productTag)) {
      //   const activeTab = document.querySelector('.tab-content.active');

      //   if (activeTab) {
      //       activeTab.querySelectorAll('.custom-dropdown').forEach(dropdown => {
      //           const input = dropdown.querySelector('.dropdown-input');
      //           const sellingPlanInput = dropdown.querySelector('.selected-selling-plan-id');
      //           if (input && input.value) {
      //             const variantId = input.value;
      //             const sellingPlanId = sellingPlanInput?.value;
      //           // Push fragrance selection along with the optional selling plan ID
      //           fragranceSelections.push({ variantId, sellingPlanId });
      //           }
      //       });
      //   }
      // }

      // add on product start  function changes

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        const oneYearSubscriptionTemplate = document.querySelector('.product-1-year-subscribe-product');

        if (oneYearSubscriptionTemplate) {
          const nameInput = document.querySelector('[data-gift-field="name"]');
          const emailInput = document.querySelector('[data-gift-field="email"]');

          const nameError = document.querySelector('.gift-recipient-name-error');
          const emailError = document.querySelector('.gift-recipient-email-error');

          let hasError = false;

          // Clear previous errors
          if (nameError) nameError.textContent = "";
          if (emailError) emailError.textContent = "";

          // 🔴 Validate name
          if (nameInput && !nameInput.value.trim()) {
            nameError.textContent = "Recipient name is required.";
            hasError = true;
          }

          // 🔴 Validate email
          if (emailInput && !emailInput.value.trim()) {
            emailError.textContent = "Recipient email is required.";
            hasError = true;
          }

           // Extra email format validation (recommended)
          if (emailInput && emailInput.value.trim()) {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailPattern.test(emailInput.value.trim())) {
              emailError.textContent = "Please enter a valid email address.";
              hasError = true;
            }
          }

          // Stop form submission if errors exist
          if (hasError) {
            return; // <-- prevents submit from continuing
          }
        }
        const dropdownSelected = document.querySelector('.dropdown-selected');

        let mainProductImage = '';
        let mainProductName = '';
        let mainProductMinQty = '';
        if (dropdownSelected) {
          mainProductImage = dropdownSelected.getAttribute('data-main-product-image') || '';
          mainProductName = dropdownSelected.getAttribute('data-main-product-name') || '';
          mainProductMinQty = dropdownSelected.getAttribute('data-main-product-qty') || '';
        }

        const productTag = this.closest('.product')?.dataset.productTag;
        const formTags = this.form?.dataset.productTags?.split(',') || [];

        // Get diffuser product ID (outside tab)
        const diffuserInput = document.querySelector('.diffuser-product');
        const diffuserProductId = diffuserInput && diffuserInput.value ? diffuserInput.value : null;

        // Gather selected fragrance variants
        let fragranceSelections = [];
        const qtyInput = this.closest('.product')?.querySelector('.quantity__input');
        const sharedQuantity = qtyInput && qtyInput.value ? parseInt(qtyInput.value, 10) : 1;

        if (formTags.includes(productTag)) {
          const activeTab = document.querySelector('.tab-content.active');
          if (activeTab) {
            activeTab.querySelectorAll('.custom-dropdown').forEach((dropdown) => {
              const input = dropdown.querySelector('.dropdown-input');
              const sellingPlanInput = dropdown.querySelector('.selected-selling-plan-id');
              if (input && input.value) {
                const variantId = input.value;
                const sellingPlanId = sellingPlanInput?.value;
                fragranceSelections.push({ variantId, sellingPlanId });
              }
            });
          }
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const activeTabId = document.querySelector('.tab-content.active')?.id;

        // 🚫 Remove default main product when on 6-fragrance
        if (activeTabId === '6-fragrance') {
          formData.delete('id');
          formData.delete('quantity');
        }

        if (fragranceSelections.length > 0 || diffuserProductId) {
          const timestamp = Date.now();
          formData.append('properties[self_key]', timestamp);

          let index = 0;

          if (activeTabId === '6-fragrance') {
            // 🚀 Add ONLY new product ID 50112603586846
            formData.append(`items[${index}][id]`, '50112603586846');
            formData.append(`items[${index}][quantity]`, sharedQuantity);
            formData.append(`items[${index}][properties][self_key]`, timestamp);
            index++;
          }

          // Add diffuser product if available
          if (diffuserProductId) {
            formData.append(`items[${index}][id]`, diffuserProductId);
            formData.append(`items[${index}][quantity]`, sharedQuantity);
            formData.append(`items[${index}][properties][_ref_key]`, timestamp);
            index++;
          }

          // Add fragrance selections
          fragranceSelections.forEach(({ variantId, sellingPlanId }) => {
            formData.append(`items[${index}][id]`, variantId);
            formData.append(`items[${index}][quantity]`, sharedQuantity);
            formData.append(`items[${index}][properties][_ref_key]`, timestamp);

            // Extra properties
            formData.append(`items[${index}][properties][_main_product_image]`, mainProductImage);
            formData.append(`items[${index}][properties][_main_product_name]`, mainProductName);
            formData.append(`items[${index}][properties][_main_product_qty]`, mainProductMinQty);

            if (sellingPlanId) {
              formData.append(`items[${index}][selling_plan]`, sellingPlanId);
            }
            index++;
          });
        }

        // ---- Add-on subscription product logic (unchanged) ----
        const clickedButton = evt.submitter;
        const isAddonProductButton = clickedButton?.classList.contains('addon_product_button');
        const isProductSubscribe = clickedButton?.dataset.subscribe === 'true';
        const mainProductId = clickedButton?.dataset.id;
        const isCompleteFragranceStarterKit = mainProductId === '49362488721694';
        const timestamp = Date.now();

        if (
          isAddonProductButton &&
          isProductSubscribe &&
          activeTabId !== '6-fragrance' &&
          activeTabId !== '3-fragrance'
        ) {
          const productDiv = document.querySelector('#subscribe_product_id');
          const mainProductQtyInput = document.querySelector('input[name="quantity"]');
          const mainProductQty = mainProductQtyInput ? parseInt(mainProductQtyInput.value, 10) : 1;
          if (productDiv && mainProductQty) {
            const subscribeProductId = productDiv.value;
            const existingItems = [...formData.entries()].filter(([key]) => key.includes('items['));
            const nextIndex = Math.floor(existingItems.length / 2);
            formData.append(`items[${nextIndex}][id]`, subscribeProductId);
            formData.append(`items[${nextIndex}][quantity]`, mainProductQty);
          }
        } else if (activeTabId === '6-fragrance') {
          const productDiv = document.querySelector('#subscribe_product_id');
          const mainProductQtyInput = document.querySelector('input[name="quantity"]');
          const mainProductQty = mainProductQtyInput ? parseInt(mainProductQtyInput.value, 10) : 1;

          if (productDiv && mainProductQty) {
            const subscribeProductId = productDiv.value;
            const existingItems = [...formData.entries()].filter(([key]) => key.includes('items['));
            const nextIndex = Math.floor(existingItems.length / 2);
            formData.append(`items[${nextIndex}][id]`, subscribeProductId);
            formData.append(`items[${nextIndex}][quantity]`, mainProductQty);
            formData.append(`items[${nextIndex}][properties][self_key]`, timestamp);
          }
        } else if (activeTabId === '3-fragrance' && isProductSubscribe) {
          const productDiv = document.querySelector('#subscribe_product_id');
          const mainProductQtyInput = document.querySelector('input[name="quantity"]');
          const mainProductQty = mainProductQtyInput ? parseInt(mainProductQtyInput.value, 10) : 1;

          if (productDiv && mainProductQty) {
            const subscribeProductId = productDiv.value;
            const existingItems = [...formData.entries()].filter(([key]) => key.includes('items['));
            const nextIndex = Math.floor(existingItems.length / 2);
            formData.append(`items[${nextIndex}][id]`, subscribeProductId);
            formData.append(`items[${nextIndex}][quantity]`, mainProductQty);
            formData.append(`items[${nextIndex}][properties][self_key]`, timestamp);
          }
        } else if (isCompleteFragranceStarterKit) {
          console.log(isCompleteFragranceStarterKit, 'run');

          const productDiv = document.querySelector('#subscribe_product_id');
          const mainProductQtyInput = document.querySelector('input[name="quantity"]');
          const mainProductQty = mainProductQtyInput ? parseInt(mainProductQtyInput.value, 10) : 1;

          if (productDiv && mainProductQty) {
            const subscribeProductId = productDiv.value;
            const existingItems = [...formData.entries()].filter(([key]) => key.includes('items['));
            const nextIndex = Math.floor(existingItems.length / 2);
            formData.append(`items[${nextIndex}][id]`, subscribeProductId);
            formData.append(`items[${nextIndex}][quantity]`, mainProductQty);
          }
        }

        // ---- cart submission ----
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      // add on product end

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
